import { AxiosRequestConfig, AxiosPromise } from 'axios';
import { Get } from './Get';
import { Post } from './Post';
import { Patch } from './Patch';
import { Delete } from './Delete';
import { ApiHelpers, APIHosts } from './ApiHelpers';
import { SYSTEM_CONSTANT } from '~/constants/system-constant';
import {
  PasskeySummaryDto,
  PasskeyRenameDto,
  PasskeyRegistrationOptionsResponse,
  PasskeyRegistrationVerifyRequest,
} from './Passkey.interface';

class PasskeyServiceController extends ApiHelpers {
  ApiHost = APIHosts.Identity;

  private get identityServerUrl() {
    const url = this.getHost(this.ApiHost) || SYSTEM_CONSTANT.IDENTITY_SERVER_URL;
    return url ? url.replace(/\/+$/, '') : '';
  }

  public Get = {
    list: (options: AxiosRequestConfig = {}): AxiosPromise<PasskeySummaryDto[]> => {
      return Get(
        `${this.identityServerUrl}/api/passkey`,
        { withCredentials: true, ...options },
      );
    },
  };

  public Post = {
    registerOptions: (options: AxiosRequestConfig = {}): AxiosPromise<PasskeyRegistrationOptionsResponse> => {
      return Post(
        `${this.identityServerUrl}/api/passkey/registration/options`,
        {},
        { withCredentials: true, ...options },
      );
    },
    registerVerify: (
      data: PasskeyRegistrationVerifyRequest,
      options: AxiosRequestConfig = {},
    ): AxiosPromise<PasskeySummaryDto> => {
      return Post(
        `${this.identityServerUrl}/api/passkey/registration/verify`,
        data,
        { withCredentials: true, ...options },
      );
    },
  };

  public Patch = {
    rename: (
      id: string,
      data: PasskeyRenameDto,
      options: AxiosRequestConfig = {},
    ): AxiosPromise<PasskeySummaryDto> => {
      return Patch(
        `${this.identityServerUrl}/api/passkey/${id}`,
        data,
        { withCredentials: true, ...options },
      );
    },
  };

  public Delete = {
    revoke: (id: string, options: AxiosRequestConfig = {}): AxiosPromise<void> => {
      return Delete(
        `${this.identityServerUrl}/api/passkey/${id}`,
        {},
        { withCredentials: true, ...options },
      );
    },
  };
}

export const PasskeyService = new PasskeyServiceController();
